import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import { keyForCodeForSection, sectionLockStatus } from '@/pages/timeline/sections/timeline/timelineSections/constants'
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from "moment";
import { setSeriesWatchLaterDateApiCall, startSeriesApiCall } from "@/services/api"
import { updateWatchLaterAt } from "@/store/slices/timeline/timelineSlice"

import WatchModle1 from '@/components/timeline/watchModle1'
import WatchModle2 from '@/components/timeline/watchModle2'
import { seriesStatus } from '@/pages/dashboard/constants'
import WatchView from './view';
import { toast, Toaster } from 'sonner';
import { notifyParentToExtendCourse } from '@/utils/mainSiteNavigateFromIframe';


export default function Watch(props: any) {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { timeline, common } = useLocalTranslation();
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const timelineAccordionStatus = useSelector((state: RootState) => state.timelineAccordionStatusReducer.timelineAccordionStatus);
    const [isSectionLocked, setIsSectionLocked] = useState(false)

    const [showModal_1, setShowModal_1] = useState(false);
    const [showModal_2, setShowModal_2] = useState(false);
    const [startCourseBtnLoading, setStartCourseBtnLoading] = useState(false)
    const [iWillStartLaterBtnLoading, setIWillStartLaterBtnLoading] = useState(false)
    const [stepForModal1, setStepForModal1] = useState(0)
    const [stepForModal2, setStepForModal2] = useState(0)


    useEffect(() => {
        handleIsSectionLocked()
    }, [timelineAccordionStatus])

    const handleIsSectionLocked = () => {
        if (timelineAccordionStatus[keyForCodeForSection.watch] === sectionLockStatus.locked) {
            setIsSectionLocked(true)
        } else {
            setIsSectionLocked(false)
        }
    }

    // ---------- START : Modal code -----------------------------
    const openPop = (source: string) => {
        if (source === "startCourse") {
            handleOpenModal_1()
        } else {
            handleOpenModal_2()
        }
    }

    const handleOpenModal_2 = () => {
        setShowModal_2(true)
    }

    const handleCloseModal_2 = () => {
        setShowModal_2(false)
    }

    const setCourseStartDate = async (date: any) => {
        handleCloseModal_2()
        setIWillStartLaterBtnLoading(true)
        const dateToSave = moment(date).format("YYYY-MM-DD");
        const playload = {
            purchaseId: timelineDetails.purchaseId,
            seriesId: timelineDetails.series[0].seriesId,
            date: dateToSave
        }
        // debugger
        const setSeriesWatchLaterDateApiCallStatus = await setSeriesWatchLaterDateApiCall(playload)
        if (setSeriesWatchLaterDateApiCallStatus.status) {
            setStepForModal2(stepForModal2 + 1)
            handleOpenModal_2()
            // debugger
            dispatch(updateWatchLaterAt(playload))
        } else {
            toast.error(common.statusText.issueInUpdating)
        }
        setIWillStartLaterBtnLoading(false)
    }



    const handleOpenModal_1 = () => {
        setShowModal_1(true)
    }

    const startCourseNow = async () => {
        handleCloseModal_1()
        setStartCourseBtnLoading(true)
        const currentDate = new Date();
        const dateToSave = moment(currentDate).format("YYYY-MM-DD");
        const seriesId = timelineDetails.series[0].seriesId
        const purchaseId = timelineDetails.purchaseId
        const playload = {
            purchaseId: purchaseId,
            seriesId: seriesId,
            date: dateToSave
        }
        const startSeriesApiCallStatus = await startSeriesApiCall(playload)
        // debugger
        if (startSeriesApiCallStatus.status) {
            setStepForModal1(stepForModal1 + 1)
            handleOpenModal_1()
        } else {
            toast.error(common.statusText.issueInUpdating)
        }
        setStartCourseBtnLoading(false)
    }

    const handleCloseModal_1 = () => {
        setShowModal_1(false)
        if (stepForModal1 === 1) {
            handleRedirectToWatchScreen()
        }
    }

    const handleRedirectToWatchScreen = () => {
        if (timelineDetails && timelineDetails.series
            && timelineDetails.series.length > 0) {
            const seriesId = timelineDetails.series[0].seriesId
            const firstVideoDocId = timelineDetails.series[0].firstVideoDocId
            const purchaseId = timelineDetails.purchaseId
            if (seriesId && firstVideoDocId && purchaseId) {
                const source = location.pathname.split("/")[1]
                let navigate_ = `/watch?series=${seriesId}&video=${firstVideoDocId}`
                navigate(navigate_, {
                    state: {
                        source: `/${source}`,
                        purchaseId: purchaseId,
                    },
                });
            }
        }
    }
    // ---------- END : Modal code -----------------------------


    const isSeriesWatchLaterAtAvaliable = () => {
        let seriesWatchLaterAt = false
        if (timelineDetails && timelineDetails.series
            && timelineDetails.series[0] && timelineDetails.series[0]
            && timelineDetails.series[0].seriesWatchLaterAt) {
            const isPastDate = moment(timelineDetails.series[0].seriesWatchLaterAt).isBefore(moment());
            if (!isPastDate) {
                seriesWatchLaterAt = true
            }
        }
        return seriesWatchLaterAt
    }

    const handleExtendDuration = () => {
        if (!timelineDetails?.courseSeoUrlSlug) return;

        notifyParentToExtendCourse({
            courseSeoUrlSlug: timelineDetails.courseSeoUrlSlug
        });
    }

    const areAllSeriesExpired = () => {
        // return true // testing
        if (timelineDetails && timelineDetails.series && timelineDetails.series.length > 0) {
            const seriesList = timelineDetails.series
            return seriesList.every((serie: { seriesStatus: string; }) => serie.seriesStatus === seriesStatus.expired);
        }
        return false
    }


    return (
        <>
            <WatchView
                timelineDetails={timelineDetails}
                openPop={openPop}
                isSectionLocked={isSectionLocked}
                startCourseBtnLoading={startCourseBtnLoading}
                iWillStartLaterBtnLoading={iWillStartLaterBtnLoading}
                isSeriesWatchLaterAtAvaliable={isSeriesWatchLaterAtAvaliable}
                handleExtendDuration={handleExtendDuration}
                areAllSeriesExpired={areAllSeriesExpired}
            />

            <WatchModle1
                show={showModal_1}
                modalTitle={timeline.watchSection.popUp1.p3}
                handleClose={handleCloseModal_1}
                startCourseNow={startCourseNow}
                stepForModal1={stepForModal1}
            />

            <WatchModle2
                show={showModal_2}
                handleClose={handleCloseModal_2}
                setCourseStartDate={setCourseStartDate}
                stepForModal2={stepForModal2}
            />
        </>
    );
};


